import React from 'react';
import { Flex, StyledCode } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { getProviderConfig } from 'common/utils/provider.utils';
import {
  StyledLinkPat,
  StyledPatExplanationWrapper
} from './PatGitProviderInstructions.style';

const PatExplanation = ({ provider, scopes }) => {
  return (
    <Flex direction='column' gap='2rem'>
      <StyledPatExplanationWrapper>
        <Flex gap='0.6rem' items='center' mb='2rem'>
          <Flex self='flex-start'>
            <Icon name='erroricon' color='orangePeel' size='medium' />
          </Flex>
          <Text size='x-medium' lineHeight='140%' weight='500' mt='0.1rem'>
            When connecting with Personal Access Token
          </Text>
        </Flex>
        <Flex direction='column' mb='1rem' ml='1rem'>
          <Text color='shuttleGray' size='x-medium' lineHeight='150%'>
            1. Create a Personal Access Token on {provider.name}
            {provider.name === 'GitLab' && (
              <>
                <br />
                Set the service account as <strong>Maintainer</strong> or{' '}
                <strong>Owner</strong>
              </>
            )}
          </Text>
          <Text color='shuttleGray' size='x-medium' lineHeight='150%'>
            2. Ensure the required scopes are checked:
          </Text>
        </Flex>

        <Flex gap='0.4rem' wrap='wrap' ml='1rem' width='29rem'>
          {scopes.map(scope => (
            <StyledCode margin='0' key={scope}>
              {scope}
            </StyledCode>
          ))}
        </Flex>
      </StyledPatExplanationWrapper>
      <StyledLinkPat href={provider.helpDocForPAT} target={'_blank'}>
        Learn more
      </StyledLinkPat>
    </Flex>
  );
};

const PatGitProviderInstructions = ({ provider, scopes }) => (
  <Flex height='100%' items='center' justify='center' width='100%' mt='-9rem'>
    <PatExplanation
      provider={getProviderConfig({ provider, isCloudProvider: true })}
      scopes={scopes || []}
    />
  </Flex>
);

export default PatGitProviderInstructions;
